import React, { useState } from 'react';
import { Link } from 'react-scroll';
import styles from '../../styles/components/Navbar.module.css';
import logo from '../../assets/nana_cece_logo_bar.png';
import { FaInstagram, FaFacebookF, FaTiktok, FaYoutube, FaPinterest, FaBars, FaTimes } from 'react-icons/fa';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <img src={logo} alt="Nana + Cece Logo" className={styles.logoImage} />
      </div>
      
      <div className={styles.mobileMenuIcon} onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>

      <div className={`${styles.menuItems} ${isMenuOpen ? styles.showMenu : ''}`}>
        <ul className={styles.navLinks}>
          <li><Link to="aboutUs" smooth={true} duration={500} onClick={toggleMenu}>About</Link></li>
          <li><Link to="recommendations" smooth={true} duration={500} onClick={toggleMenu}>Recommendations</Link></li>
          <li><Link to="content" smooth={true} duration={500} onClick={toggleMenu}>Blog</Link></li>
        </ul>
        <div className={styles.socialLinks}>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          <a href="https://www.pinterest.com/" target="_blank" rel="noopener noreferrer"><FaPinterest /></a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;